import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { ArrowLeft, MailCheck } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [devLink, setDevLink] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/forgot-password", { email });
      setDone(true);
      if (r.data.reset_link_dev) setDevLink(r.data.reset_link_dev);
      toast.success("Si cet email existe, un lien vient d'être envoyé.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center px-4 py-12 bg-[#F9FAF6]" data-testid="forgot-password-page">
      <div className="w-full max-w-md bg-white border border-[#E5EAE5] rounded-3xl p-8 lg:p-10">
        <Link to="/auth" className="inline-flex items-center gap-2 text-sm text-[#4B634B] hover:text-[#7AC143] mb-4">
          <ArrowLeft className="w-4 h-4" /> Retour à la connexion
        </Link>
        <h1 className="text-3xl font-black tracking-tighter">Mot de passe oublié</h1>
        <p className="text-[#4B634B] mt-1 text-sm">Saisissez votre email pour recevoir un lien de réinitialisation.</p>

        {done ? (
          <div className="mt-8 text-center" data-testid="forgot-password-confirmation">
            <MailCheck className="w-16 h-16 text-[#7AC143] mx-auto mb-4" />
            <p className="text-[#1A2E1A] font-semibold">Vérifiez votre boîte de réception.</p>
            <p className="text-[#4B634B] text-sm mt-2">Si un compte existe pour <strong>{email}</strong>, vous recevrez un lien valide 1 heure.</p>
            {devLink && (
              <div className="mt-4 text-xs bg-[#FACC15]/10 border border-[#FACC15]/40 rounded-xl p-3 text-left" data-testid="forgot-password-dev-link">
                <p className="font-semibold text-[#1A2E1A] mb-1">Mode test :</p>
                <a className="underline text-[#7AC143] break-all" href={devLink}>{devLink}</a>
              </div>
            )}
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-8">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" />
            </div>
            <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full bg-[#7AC143] hover:bg-[#67BC2A] text-white rounded-full py-6 font-bold">
              {loading ? "Envoi..." : "Envoyer le lien"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
